<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="400" persistent>
      <v-card>
        <v-card-title >{{ $t('confirm.confirmunhide') }} <v-spacer></v-spacer>
          <v-icon :color="color.theme" dense dark size="35">mdi-eye</v-icon>
        </v-card-title>
        <v-divider></v-divider>
          <v-card-text  class="pa-1 pt-1 pb-1 text-center" >
            <p class="pl-4 ma-2">{{ $t('confirm.unhide') }} &nbsp; {{filedata.file_name}}&nbsp; ?</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="$emit('closedialog'), $emit('closecurrent')">{{ $t('confirm.closecomfirm') }}</v-btn>
          <v-btn :color="color.theme" :dark="color.darkTheme" @click="$emit('hidefile'), $emit('closecurrent')">{{ $t('confirm.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
  props: ["show","filedata"],
  computed:{
  ...mapState(["username", "authorize", "account_active", "color","role_level"]),
  ...mapState({ processloader: "loading" }),
  ...mapGetters([
    "dataUsername",
    "dataAuthorize",
    "dataAccountActive",
    "dataAccesstoken",
    "dataBusinessProfile",
    "dataCitizenProfile",
    "dataDepartmentAccessId",
    "dataAccountId",
  ]),
  }
};
</script>

<style>
</style>